<template>
  <div v-if="isVisible" tabindex="-1"
    class="fixed inset-0 z-50 flex justify-center items-center w-full h-screen bg-black bg-opacity-50">
    <div class="relative p-4 w-full max-w-md">
      <div class="relative bg-white rounded-lg shadow-md dark:bg-gray-800">
        <button @click="handleCancel" type="button"
          class="absolute top-3 end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
          <IconX />
          <span class="sr-only">Close modal</span>
        </button>
        <div class="p-4 md:p-5 text-center">
          <div v-if="options.icon === 'warning'"
            class="mx-auto mb-4 text-gray-400 dark:text-gray-200 flex justify-center">
            <IconWarningCircle />
          </div>
          <div v-else-if="options.icon === 'question'"
            class="mx-auto mb-4 text-teal-400 dark:text-teal-200 flex justify-center">
            <IconQuestionCircle />
          </div>
          <div v-else-if="options.icon === 'info'"
            class="mx-auto mb-4 text-teal-400 dark:text-teal-200 flex justify-center">
            <IconInfoCircle />
          </div>
          <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">{{ options.title }}</h3>
          <p v-if="options.description" class="mb-4 text-sm text-gray-600 dark:text-gray-300 break-words">
            <span v-html="formattedDescription"></span>
          </p>
          <button @click="handleConfirm" type="button" :class="[
            'ddai-btn-primary',
            confirmButtonClass
          ]">
            {{ options.confirmText }}
          </button>
          <button @click="handleCancel" type="button" class="ddai-btn-secondary ms-3">
            {{ options.cancelText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useConfirmModal } from '~/composables/useConfirmModal';
import IconX from '../icons/icon-x.vue';
import IconWarningCircle from '../icons/icon-warning-circle.vue';
import IconQuestionCircle from '../icons/icon-question-circle.vue';
import IconInfoCircle from '../icons/icon-info-circle.vue';

const { isVisible, options, handleConfirm, handleCancel } = useConfirmModal();

const confirmButtonClass = computed(() => {
  switch (options.value.type) {
    case 'danger':
      return 'bg-red-600 hover:bg-red-800 focus:ring-red-300 dark:focus:ring-red-800';
    case 'warning':
      return 'bg-orange-500 hover:bg-orange-600 focus:ring-orange-300 dark:focus:ring-orange-800';
    case 'info':
    default:
      return '';
  }
});

// Format description to handle exclamation mark styling
const formattedDescription = computed(() => {
  if (!options.value.description) return '';
  
  // Replace (!) with the styled exclamation mark
  return options.value.description.replace(/\(!+\)/g, match => {
    return `<span class="inline-flex items-center justify-center flex-shrink-0 w-5 h-5 ml-1 mr-1 text-xs font-bold text-white bg-orange-600 rounded-full">!</span>`;
  });
});
</script>